export const AppRoutes = {
  AUTH: "/auth",
  LOGIN: "/auth/login",
  /** Receiving end of the Classic/New cross-origin auth handoff. */
  AUTH_HANDOFF: "/auth/handoff",
  HOME: "/",
  DASHBOARD: "/dashboard",
  DICOM: "/dicom",
  SCAN_CENTRES: "/scan-centres",
  SCAN_CENTER_SUMMARY: "/scan-centers/:scanCenterId/summary",
  CASES: "/cases",
  CASE_DETAIL: "/cases/:caseId",
  GENERATE_REPORT: "/cases/:caseId/generate-report",
  GENERATE_ONLYOFFICE_REPORT: "/cases/:caseId/generate-onlyoffice-report",
  CASE_DETAIL_GUEST: "/guest/cases/:caseId",
  SHARED_PAGE: "/shared_page",
  DOCTORS: "/doctors",
  REFERRING_DOCTORS: "/referring-doctors",
  CUSTOM_TAGS: "/custom-tags",
  SCAN_TYPES: "/scan-types",
  BODY_PARTS: "/body-parts",
  REPORT_TEMPLATES: "/report-templates",
  REPORT_MACROS: "/report-macros",
  DOCTOR_SUMMARY: "/doctors/:doctorId/summary",
  ADMINS: "/admins",
  ISSUES: "/issues",
  PROFILE: "/profile",
  CASE_DUMMY: "/dummyCases",
  /** In-app release notes (e.g. from notifications). */
  RELEASE_NOTES: "/release-notes",
};
